import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

function Section({ label, actions, children, className, showDivider = true }) {
  return (
    <div className={className}>
      <div className={'flex flex-col gap-y-3 mb-5'}>
        <div className="flex flex-row w-full justify-between items-center">
          <h3 className="text-slate-700">{label}</h3>
          <div className="flex flex-row gap-x-3">
            {actions &&
              actions.map((action, index) => (
                <Button
                  key={`action-${index}`}
                  size="small"
                  outlined
                  rounded
                  loading={action.loading}
                  label={action.label}
                  iconPos="left"
                  icon={`pi ${action.icon}`}
                  onClick={action.onClick}
                  severity={action.severity}
                  className="font-semibold"
                />
              ))}
          </div>
        </div>
        <div className="flex flex-col gap-y-5">{children}</div>
      </div>
      {showDivider && <Divider />}
    </div>
  );
}

export default Section;
